/**
 * @name realEstateReplace
 * @description Načte náhodný nemovitostní inzerát a nahradí poslední článek v doporučených článcích.
 */
export const realEstateReplace = async () => {
    try {
        const containerElement = document.querySelector(
            '[data-real-estate-replace-article="true"]',
        ); // Najdeme kontejner pro nahrazení článku.

        if (!containerElement) return;

        // Najdeme všechny články v kontejneru
        const articles = containerElement.querySelectorAll('.recommended .list-article');

        if (articles.length === 0) return;

        // Posledni clanekk
        const lastArticle = articles[articles.length - 1];

        // Stáhneme nemovitostní feed
        const realEstateResp = await fetch(
            'https://nemovitosti.blesk.cz/export/adverts_feed/json/cr-vse/',
        );
        if (!realEstateResp.ok) {
            throw new Error('Failed to fetch real estate feed');
        }

        const json = await realEstateResp.json();
        const items = Array.isArray(json) ? json : [];
        if (items.length === 0) return;

        // Náhodný inzerát
        const randomItem = items[Math.floor(Math.random() * items.length)];

        // Vytvoříme HTML pro nemovitostní článek se stejnou strukturou
        const realEstateHTML = `
            <article class="list-article list-article--horizontal-small" data-track-element-id="realEstateReplace" data-track-list="{&quot;item&quot;: {&quot;elementId&quot;:&quot;realEstateReplace&quot;,&quot;type&quot;:&quot;article&quot;,&quot;list&quot;:&quot;clankyOdjinudDoporucujeme&quot;,&quot;systemId&quot;:&quot;nemovitosti&quot;,&quot;title&quot;:&quot;${(randomItem.headline || '').replace(/"/g, '&quot;')}&quot;,&quot;url&quot;:&quot;${randomItem.url}&quot;,&quot;source&quot;:&quot;realEstate&quot;} }">
                <div class="list-article__title">
                    <a href="${randomItem.url}" title="${randomItem.headline || 'Nemovitost'}" target="_blank" onclick="dataLayer.push({'event':'ga.event','eCategory':'Boxy SOB','eAction':'Real Estate Nahrazeni','eLabel':'${randomItem.url}'});">
                        ${randomItem.headline || 'Nemovitost'}
                    </a>
                </div>
                <a class="list-article__image" href="${randomItem.url}" title="${randomItem.headline || 'Nemovitost'}" target="_blank" onclick="dataLayer.push({'event':'ga.event','eCategory':'Boxy SOB','eAction':'Real Estate Nahrazeni','eLabel':'${randomItem.url}'});">
                    <picture class="loading-placeholder item-loaded" style="padding-bottom: 60%">
                        <img src="${randomItem.image_1 || randomItem.image_2 || ''}" alt="${randomItem.headline || 'Nemovitost'}" title="${randomItem.headline || 'Nemovitost'}" width="150" height="90" class="lazyload recommended loaded" loading="lazy" style="max-height: 90px;">
                    </picture>
                </a>
                <div class="list-article__category-name">
                    <span>${randomItem.price?.value || ''}</span>
                </div>
            </article>
        `;

        // Nahradíme poslední článek
        lastArticle.replaceWith(document.createRange().createContextualFragment(realEstateHTML));

        // Re-initialize lazy loading pro nový obrázek
        if (window.cncMiniLazyload && typeof window.cncMiniLazyload === 'function') {
            window.cncMiniLazyload();
        }

        if (window.gtmService && window.gtmService.observe instanceof Function) {
            window.gtmService.observe();
        }
    } catch (err) {
        // silent fail — bez vrácení hodnoty
        console.log('Real estate replacement failed', err); // eslint-disable-line no-console
    }
};
